import { Bq1GeneralInformationM } from "../models/bq1-general-information.model";
import React from "react";

export function Bq1CommsAndElectronics(
  form: Bq1GeneralInformationM,
  updateForm: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void,
  readonly: boolean,
) {
  return (
    <div>
      <h2 className="mb-2 mt-[120px] text-lg font-semibold">Communications & Electronics</h2>
      <br />
      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Call sign */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Call sign</label>
          <input
            disabled={readonly}
            type="text"
            name="callSign"
            value={form.callSign}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Vessel's telephone (INMARSAT) */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">
            Vessel's telephone <sup className="font-medium text-gray-500">(INMARSAT)</sup>
          </label>
          <input
            disabled={readonly}
            type="text"
            name="vesselTelephoneInmarsat"
            value={form.vesselTelephoneInmarsat}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Telex */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Vessel's telex number</label>
          <input
            disabled={readonly}
            type="text"
            name="vesselTelexNumber"
            value={form.vesselTelexNumber}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Fax */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Vessel's fax number</label>
          <input
            disabled={readonly}
            type="text"
            name="vesselFaxNumber"
            value={form.vesselFaxNumber}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Email */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Vessel's email address</label>
          <input
            disabled={readonly}
            type="text"
            name="vesselEmailAddress"
            value={form.vesselEmailAddress}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* MMSI */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">
            Vessel's MMSI No.{" "}
            <sup className="font-medium text-gray-500">(Maritime Mobile Selective Call Identity Code)</sup>
          </label>
          <input
            disabled={readonly}
            type="text"
            name="vesselMmsiNo"
            value={form.vesselMmsiNo}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Electrical supply */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">
            Vessels onboard electrical supply{" "}
            <sup className="font-medium text-gray-500">(volts, hertz and type of fittings)</sup>
          </label>
          <input
            disabled={readonly}
            type="text"
            name="vesselElectricalSupply"
            value={form.vesselElectricalSupply}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>
    </div>
  );
}
